<template>
  <div>
    <b-overlay :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm">
      <validation-observer ref="channelGroupForm">
        <b-form @submit.prevent=""
          @reset.prevent="resetForm">
          <validation-provider #default="validationContext"
            name="Tên nhóm"
            vid="name"
            rules="required">
            <b-form-group>
              <template #label>
                <label class="d-block font-weight-bolder pb-0">Tên nhóm <span class="text-danger">*</span></label>
              </template>
              <b-form-input type="text"
                id="name"
                v-model="frmData.name"
                :state="getValidationState(validationContext)"
                placeholder="Nhập..." />
              <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext"
            name="App name"
            vid="app_name"
            rules="required">
            <b-form-group>
              <template #label>
                <label class="d-block font-weight-bolder pb-0">App name<span class="text-danger">*</span></label>
              </template>
              <b-form-input type="text"
                id="app_name"
                v-model="frmData.app_name"
                :state="getValidationState(validationContext)"
                placeholder="Nhập..." />
              <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext"
            name="Station"
            vid="station"
            rules="required">
            <b-form-group>
              <template #label>
                <label class="d-block font-weight-bolder pb-0">Station<span class="text-danger">*</span></label>
              </template>
              <b-form-input type="text"
                id="station"
                v-model="frmData.station"
                :state="getValidationState(validationContext)"
                placeholder="Nhập..." />
              <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox value="1"
                v-model="frmData.status"> {{ $t('Kích hoạt') }} </b-form-checkbox>
            </b-form-group>
          </b-col>
          <div class="d-flex mt-1">
            <b-button variant="primary"
              type="submit"
              @click.prevent="validationForm"> {{ $t('Save') }} </b-button>
          </div>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import { required, email, alphaNum, min, max, } from '@validations'
import store from '@/store'
import { ref } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormCheckbox, BFormCheckboxGroup, BOverlay } from 'bootstrap-vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { showToast, useRouter } from '@core/utils/utils';
export default {

  components: {
    BForm,
    BOverlay,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormCheckboxGroup,
  },
  props: {
    dataEdit: {
      type: Object,
      default: null
    },
    dataParent: {
      type: Array,
      default: null
    }
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const loading = ref(false)
    const blankData = {
      name: '',
      app_name: '',
      station: '',
      desc: '',
      status: 0
    }

    const frmData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData))
    }
    if (Object.keys(props.dataEdit).length > 0) {
      frmData.value = props.dataEdit
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)


    return {
      frmData,
      refFormObserver,
      resetForm,
      getValidationState,
      resetfrmData,
      loading
    }
  },
  methods: {
    onSubmit() {
      this.loading = true

      if (this.frmData.id) {
        store.dispatch('channel/update', { data: this.frmData, id: this.frmData.id, card_type: 'channel_group' })
          .then(response => {
            const result = response.data;
            this.loading = false;
            if (result.code === 200) {
              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else {
              if (result.errors.length > 0) {
                this.$refs.channelGroupForm.setErrors(result.errors);
              } else {
                showToast(result.message);
              }
            }
          })
      } else {

        store.dispatch('channel/create', { card_type: 'channel_group', params: this.frmData })
          .then(response => {
            const result = response.data;
            this.loading = false;
            if (result.code === 200) {

              showToast(result.message, { variant: 'success' });
              this.$emit('updateList');
              this.resetfrmData()
            } else {
              if (result.errors.length > 0) {
                this.$refs.channelGroupForm.setErrors(result.errors);
              } else {
                showToast(result.message);
              }
            }
          })
      }
    },
    validationForm() {
      this.errorMessage = {}
      this.$refs.channelGroupForm.validate().then(success => {
        if (success) {
          this.onSubmit();
        }
      })
    },
  }
}
</script>
<style lang="scss">
.col-form-label {
  font-size: 1.1rem;
  font-weight: bold
}

.custom-control-label {
  cursor: pointer;
}

.custom-control.custom-checkbox {
  padding-bottom: 0.5rem;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>